import Api from '.';

/**
 *
 * Retrieve all branches.
 */
export function getBranches() {
  return Api.get('/branch');
}

/**
 *
 * Retrieve branch by id.
 */
export function lazyGetBranches({ search, page, perPage }) {
  return Api.get(`/branch/lazy?search=${search}&page=${page}&perPage=${perPage}`);
}

/**
 *
 * Retrieve branch by id.
 */
export function getBranch(id) {
  return Api.get(`/branch/${id}`);
}

/**
 *
 * Create branch.
 */
export function createBranch(branch) {
  return Api.post('/branch', branch);
}

/**
 *
 * Update branch status.
 */
export function reactivateBranch(id) {
  return Api.put(`/branch/${id}/reactivate`);
}

/**
 *
 * Update branch status.
 */
export function deactivateBranch(id) {
  return Api.put(`/branch/${id}/deactivate`);
}

/**
 *
 * Update branch.
 */
export function updateBranch(id, branch) {
  return Api.put(`/branch/${id}`, branch);
}
